import { SITE_URL } from '@/constants/site';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import ProductFinds from './components/ProductFinds';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

export default function Home() {
  const siteUrl = SITE_URL;

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            '@id': siteUrl + '/#website',
            name: 'Kakobuy Finds',
            url: siteUrl,
            description: 'Kakobuy Spreadsheet – największa baza produktów i finds. Odkrywaj sprawdzone kategorie, aktualne listy zakupowe i najlepsze okazje.',
            inLanguage: 'pl',
            image: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png',
            potentialAction: {
              '@type': 'SearchAction',
              target: {
                '@type': 'EntryPoint',
                urlTemplate: siteUrl + '/?s={search_term_string}',
              },
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <AboutSection />
        <ProductFinds />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}